<template>
  <section class="badges">
    <div class="container">
      <div class="badges__card">
        <div class="badges__grid">
          <div
            v-for="badge in badges"
            :key="badge.title"
            class="badges__item"
          >
            <div class="badges__icon" :style="{ '--badge-color': badge.color }">
              {{ badge.icon }}
            </div>
            <div class="badges__info">
              <h4 class="badges__title">{{ badge.title }}</h4>
              <p class="badges__desc">{{ badge.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { badges } from '../data/site'

export default {
  name: 'BadgeSection',
  data() {
    return { badges }
  }
}
</script>

<style scoped>
.badges {
  position: relative;
  z-index: 2;
  margin-top: -28px;
  padding: 0 0 48px;
}

.badges__card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid var(--color-border, #eef1f6);
  box-shadow: 0 12px 40px rgba(0, 30, 80, 0.08);
  padding: 28px 32px;
}

.badges__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.badges__item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 4px;
  border-radius: var(--radius-md, 12px);
  transition: background 0.25s ease;
}

.badges__item:hover {
  background: var(--color-bg-soft, #f7f9fc);
}

.badges__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: var(--badge-color);
}

.badges__info {
  min-width: 0;
  text-align: left;
}

.badges__title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 2px;
  line-height: 1.3;
}

.badges__desc {
  font-size: 12px;
  color: #888;
  line-height: 1.4;
}

@media (max-width: 960px) {
  .badges__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 16px;
  }

  .badges__card {
    padding: 24px 20px;
  }
}

@media (max-width: 560px) {
  .badges__grid {
    grid-template-columns: 1fr;
  }

  .badges {
    margin-top: -16px;
  }
}
</style>
